import { MemberDetailsSection } from "./MemberDetailsSection";
import { tsr } from "~/utils/client";
import { Spinner } from "~/components/ui/spinner";
import { OrgHierarchyList } from "./OrgHierarchyList";

type Props = {
  memberId: string;
};
export const OrgHierarchy = ({ memberId }: Props) => {
  const { data, isLoading } = tsr.members.getOrgHierarchy.useQuery({
    queryKey: ["memberOrgHierarchy", memberId],
    queryData: {
      params: { memberId },
    },
  });

  const hierarchy = data?.body;

  return (
    <MemberDetailsSection title="Organisation Hierarchy">
      {isLoading ? <Spinner /> : <OrgHierarchyList hierarchy={hierarchy} />}
    </MemberDetailsSection>
  );
};
